<template>
  <div class="activity-log-container loginlog-container h-100">

    <div class="al-body">
      <b-row class="h-100 w-100">
        <b-col class="activity-panel-wrapper">
          <div class="activity-panel">
            <div style="max-width:670px" class="text-right">
              <span class="helper-text">Data older than 90 days will be automatically deleted.</span>
            </div>
            <b-row v-for="(activities,day) in activities" :key="day" class="activity-group-row">
              <b-col cols="1" class="p-0 flex-column">
                <div class="timeline-date">
                  {{day}}
                </div>
                <div class="al-line h-100">

                </div>
              </b-col>
              <b-col>
                <div class="activities-wrapper">
                  <b-row class="activity-row" v-for="(activity,index) in activities" :key="index" v-b-toggle="activity.ID">
                    <div class="row w-100">
                      <b-col cols="2">
                        <div class="a-time text-right">
                          {{activity.timeLabel}}
                        </div>

                      </b-col>
                      <b-col>
                        <div class="a-title">
                          {{activity.email}}
                        </div>
                      </b-col>
                      <b-col cols="4">
                        <div class="a-status-count">
                          <span class="count-container" v-if="activity.loginAttemptStatus">
                            <success-icon class="icon-default success" v-if="activity.loginAttemptStatus==='success'"></success-icon>
                            <span class="count">{{activity.loginAttemptStatus}}</span>
                          </span>
                        </div>
                      </b-col>
                    </div>
                    <div class="row w-100">
                      <b-collapse :id="activity.ID" class="w-100">
                        <div class="row detail-row" v-for="(activityValue,key) in activity" :key="key" v-if="shouldShow(key)">
                          <b-col>
                            <div class="site-name">
                              {{getLabel(key)}}
                            </div>
                          </b-col>
                          <b-col>
                            <div class="activitydetail-label">
                              {{activityValue}}
                            </div>
                          </b-col>
                        </div>
                      </b-collapse>
                    </div>
                  </b-row>

                </div>
              </b-col>

            </b-row>
            <!-- <b-row class="loadmore-wrapper">
              <b-col class="text-center">
                <b-btn variant="primary">Load More</b-btn>
              </b-col>
            </b-row> -->
          </div>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import SuccessIcon from '../../assets/success.svg';
import ErrorIcon from '../../assets/error.svg';

export default {
  name: 'loginactivity',
  components: {
    SuccessIcon,
    ErrorIcon
  },
  data() {
    return {
      activities: [],
      totalPages: 0
    };
  },
  created() {
    let payload = {
      requiredData: {
        getLogPageHTMLV3: 1
      }
    };
    this.$store.dispatch('sendAction', payload).then(response => {
      let results = _.map(
        response.data.getLogPageHTMLV3.logDetails,
        _.partialRight(_.pick, [
          'email',
          'accessLevel',
          'browserInfo',
          'protocol',
          'loginAttemptStatus'
        ])
      );
      this.activities = _.groupBy(
        response.data.getLogPageHTMLV3.logDetails,
        'activityLabel'
      );
      this.totalPages = response.data.getLogPageHTMLV3.totalPages;
    });
  },
  methods: {
    shouldShow(key) {
      const showKeysArray = [
        'email',
        'accessLevel',
        'browserInfo',
        'protocol',
        'loginAttemptStatus',
        'IP',
        'loginAuthType'
      ];
      return showKeysArray.indexOf(key) > -1;
    },
    getLabel(key) {
      switch (key) {
        case 'accessLevel':
          return 'Access Level';
        case 'loginAttemptStatus':
          return 'Login attempt status';
        case 'browserInfo':
          return 'Browser Info';
        case 'loginAuthType':
          return 'Login auth type';
        case 'IP':
          return 'Logged IP';
        default:
          return key;
      }
    }
  }
};
</script>

<style>
</style>
